/** 利用証明の添付・表示用（ローカル Zip 正本） */

/** file input の accept。画像全般 + PDF */
export const TPP_PROOF_ACCEPT =
  'image/*,application/pdf,.pdf,.jpg,.jpeg,.png,.webp,.gif,.bmp,.tif,.tiff,.heic,.heif';

export type TppProofDisplayKind = 'image' | 'pdf' | 'other';

const INLINE_IMAGE_MIME =
  /^(image\/(jpeg|pjpeg|png|webp|gif|bmp|x-ms-bmp|svg\+xml))$/i;

export function guessTppProofMimeFromName(filename: string): string | null {
  const ext = filename.split('.').pop()?.toLowerCase() ?? '';
  switch (ext) {
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    case 'webp':
      return 'image/webp';
    case 'gif':
      return 'image/gif';
    case 'bmp':
      return 'image/bmp';
    case 'tif':
    case 'tiff':
      return 'image/tiff';
    case 'heic':
      return 'image/heic';
    case 'heif':
      return 'image/heif';
    case 'pdf':
      return 'application/pdf';
    default:
      return null;
  }
}

export function resolveTppProofMime(
  mime: string | null | undefined,
  filename?: string | null
): string {
  const trimmed = mime?.trim();
  if (trimmed) return trimmed;
  if (filename) {
    const guessed = guessTppProofMimeFromName(filename);
    if (guessed) return guessed;
  }
  return 'application/octet-stream';
}

/** モーダル内でインライン表示できるか（HEIC 等は別タブ／DL） */
export function tppProofDisplayKind(
  mime: string | null | undefined,
  filename?: string | null
): TppProofDisplayKind {
  const resolved = resolveTppProofMime(mime, filename);
  if (resolved === 'application/pdf' || resolved.endsWith('/pdf')) return 'pdf';
  if (INLINE_IMAGE_MIME.test(resolved)) return 'image';
  if (resolved.startsWith('image/')) return 'other';
  return 'other';
}

export function isTppProofFileAllowed(file: File): boolean {
  const mime = file.type.trim().toLowerCase();
  if (mime.startsWith('image/') || mime === 'application/pdf') return true;
  const guessed = guessTppProofMimeFromName(file.name);
  return guessed != null && (guessed.startsWith('image/') || guessed === 'application/pdf');
}
